<template>
  <div id="message">
    <header-top></header-top>
    <div class="all-read" @click="oneKeyUpdateReadInfo('all')">
      全部标记已读
    </div>
    <div class="message-main">
      <div class="message-menu">
        <div
          class="message-type"
          :class="{
            active: activeName == 'System',
            message: systemUnReadCount < 10,
          }"
          @click="showMessage('System')"
        >
          <el-badge
            v-if="systemUnReadCount > 0"
            :value="systemUnReadCount"
            class="item"
            type="primary"
          >
            <svg-icon class="message-svg svg" icon-class="message" />
          </el-badge>
          <svg-icon
            v-else
            class="message-svg svg"
            icon-class="message"
          />系统消息
        </div>
        <div
          class="message-type"
          :class="{
            active: activeName == 'Estate',
            message: estateUnReadCount < 10,
          }"
          @click="showMessage('Estate')"
        >
          <el-badge
            v-if="estateUnReadCount > 0"
            :value="estateUnReadCount"
            class="item"
            type="primary"
          >
            <svg-icon class="infomation-svg svg" icon-class="infomation" />
          </el-badge>
          <svg-icon v-else class="infomation-svg svg" icon-class="infomation" />
          楼盘动态
        </div>
        <div
          class="message-type"
          :class="{
            active: activeName == 'Reservation',
            message: reservationUnReadCount < 10,
          }"
          @click="showMessage('Reservation')"
        >
          <el-badge
            v-if="reservationUnReadCount > 0"
            :value="reservationUnReadCount"
            class="item"
            type="primary"
          >
            <svg-icon class="report-svg svg" icon-class="report" />
          </el-badge>
          <svg-icon v-else class="report-svg svg" icon-class="report" />报备
        </div>
      </div>
      <div class="message-table" v-loading="loading">
        <el-tabs @tab-click="handleClick" v-model="tabsIndex">
          <el-tab-pane label="未读" name="未读"> </el-tab-pane>
          <el-tab-pane label="已读" name="已读"> </el-tab-pane>
        </el-tabs>
        <div
          class="clear-message"
          @click="oneKeyUpdateReadInfo"
          v-if="showClear"
        >
          一键已读
        </div>
        <div class="message-list" v-if="showList">
          <div
            class="message-box"
            v-for="(item, index) in messageList"
            :key="index"
          >
            <div class="name" v-if="activeName == 'System'">
              <span
                class="icon"
                :class="{ isRead: query.IsRead }"
                v-if="!item.isRead"
              ></span>
              <span class="icon-read" v-else></span>
              {{ item.content.title }}
            </div>
            <div class="name" v-else-if="activeName == 'Estate'">
              <span
                class="icon"
                :class="{ isRead: query.IsRead }"
                v-if="!item.isRead"
              ></span>
              <span class="icon-read" v-else></span>【{{ item.content.name }}】
              <!-- {{ item.content.summary }} -->
            </div>
            <div class="name" v-else-if="activeName == 'Reservation'">
              <span
                class="icon"
                :class="{ isRead: query.IsRead }"
                v-if="!item.isRead"
              ></span>
              <span class="icon-read" v-else></span>【{{
                item.content.flowStatus
              }}】
              {{ item.content.estateName }}
            </div>
            <div class="content"  v-if="activeName == 'System'">
              {{ item.content.content | valLength(60) }}
            </div>
            <div class="content"  v-if="activeName == 'Estate'">
              {{ item.content.summary | valLength(60) }}
            </div>
            <div class="content" v-if="activeName == 'Reservation'">
              <div class="content-detail">
                楼盘：{{ item.content.estateName }}，客户{{
                  item.content.customerName
                }}
              </div>
              <div class="content-detail">
                经纪人：{{ item.content.organizationUnit }}-{{
                  item.content.brokerName
                }}
              </div>
              <div class="content-detail">
                到访时间：{{ item.content.creationTime }}，来访人数{{
                  item.content.reservationCount
                }}
              </div>
              <div class="content-detail">
                报备时间：{{ item.content.reviewTime }}
              </div>
            </div>
            <div class="details" @click="showDetails(item.id, index)">
              查看详情
            </div>
          </div>
        </div>
        <el-pagination
          v-if="showList"
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="query.maxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>

        <div class="none-box" v-else>
          <img src="@/assets/image/no-msg.png" alt="" />
          <div>暂无任何消息</div>
        </div>
      </div>
    </div>
    <el-drawer
      :with-header="false"
      :visible.sync="isDrawerShow"
      direction="rtl"
    >
      <div class="drawer-title">
        <!-- {{ information.name }} -->
        <span @click="isDrawerShow = false">
          <img src="@/assets/image/icon-delete.png" alt="" />
        </span>
      </div>
      <el-form label-position="left" label-width="6rem">
        <div class="basic-item">
          <div class="basic-item-main" v-if="messageInfo.content">
            <div class="name" v-if="activeName == 'System'">
              {{ messageInfo.content.title }}
            </div>
            <div class="name" v-else-if="activeName == 'Reservation'">
              【{{ messageInfo.content.flowStatus }}】
              {{ messageInfo.content.estateName }}
            </div>
            <div class="content" v-if="activeName != 'Reservation'">
              {{ messageInfo.content.content }}
            </div>
            <div class="content" v-else>
              <div class="content-detail">
                楼盘：{{ messageInfo.content.estateName }}，客户{{
                  messageInfo.content.customerName
                }}
              </div>
              <div class="content-detail">
                经纪人：{{ messageInfo.content.organizationUnit }} -
                {{ messageInfo.content.brokerName }}
              </div>
              <div class="content-detail">
                到访时间：{{ messageInfo.content.creationTime }}，来访人数{{
                  messageInfo.content.reservationCount
                }}
              </div>
              <div class="content-detail">
                报备时间：{{ messageInfo.content.reviewTime }}
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import {
  getMessageInfo,
  getSystemPageList,
  getReservationPageList,
  getEstatePageList,
  getSystemInfo,
  getEstateInfo,
  getReservationInfo,
  batchUpdateReadInfo,
  oneKeyUpdateReadInfo,
} from "@/http/api/message.js";
import bus from "@/utils/messageBus";
import headerTop from "@/components/HeaderTop";
export default {
  components: {
    headerTop,
  },
  data() {
    return {
      loading: true,
      showList: true,
      systemUnReadCount: 0,
      estateUnReadCount: 0,
      reservationUnReadCount: 0,
      activeName: "System",
      tabsIndex: "未读",
      pageIndex: 1,
      total: 0,
      isDrawerShow: false,
      query: {
        IsRead: false,
        skipCount: 0,
        maxResultCount: 20,
      },
      messageList: [],
      messageInfo: {},
      showClear: true,
    };
  },
  mounted() {
    this.getMessage();
    this.getMessageList("System");
  },
  methods: {
    oneKeyUpdateReadInfo(val) {
      let query = {
        messageType: this.activeName,
      };
      if (val == "all") {
        query.messageType = "";
      }
      oneKeyUpdateReadInfo(query).then((res) => {
        console.log(res);
        if (res.code == 10200) {
          this.getMessageList(this.activeName);
          this.getMessage()
          bus.$emit('rush','rush');
        }
      });
    },
    showDetails(id, index) {
      if (this.activeName == "System") {
        getSystemInfo(id).then((res) => {
          this.messageInfo = res.result;
          this.isDrawerShow = true;
          this.batchUpdateReadInfo(id, index);
        });
      } else if (this.activeName == "Estate") {
        getEstateInfo(id).then((res) => {
          console.log(res.result.content.informationId,222);
          let informationId = res.result.content.informationId
          this.batchUpdateReadInfo(id, index);
          this.$router.push({
            path: `/information/information-preview/${informationId}`,
          });
        });
      } else if (this.activeName == "Reservation") {
        getReservationInfo(id).then((res) => {
          this.messageInfo = res.result;
          this.isDrawerShow = true;
          this.batchUpdateReadInfo(id, index);
        });
      }
    },
    batchUpdateReadInfo(id, index) {
      batchUpdateReadInfo([id]).then((res) => {
        // this.getMessageList(this.activeName);
        this.messageList[index].isRead = true;
        this.getMessage();
      });
    },
    handleSizeChange(val) {
      //console.log("更改的页面数量", val);
      this.query.maxResultCount = val;
      this.getMessageList(this.activeName);
    },
    handleCurrentChange(val) {
      //console.log("跳转的指定页", val);
      this.pageIndex = val;
      this.getMessageList(this.activeName);
    },
    handleClick(tab, event) {
      //console.log(this.tabsIndex, 123, tab.label);
      this.query.IsRead = tab.label == "未读" ? false : true;
      this.messageList = [];
      this.getMessageList(this.activeName);
    },
    showMessage(val) {
      this.activeName = val;
      this.query.IsRead = false;
      this.tabsIndex = "未读";
      this.messageList = [];
      this.getMessageList(val);
    },
    getMessageList(val) {
      this.loading = true;
      this.showList = true;
      this.query.skipCount = (this.pageIndex - 1) * this.query.maxResultCount;
      if (val == "System") {
        getSystemPageList(this.query).then((res) => {
          setTimeout(() => {
            this.loading = false;
            this.messageList = res.result.items;
            this.total = res.result.totalCount;
            if (res.result.items.length == 0) {
              this.showList = false;
              this.showClear = false;
            } else {
              this.showClear = true;
            }
          }, 500);
        });
      } else if (val == "Estate") {
        getEstatePageList(this.query).then((res) => {
          setTimeout(() => {
            this.loading = false;
            this.messageList = res.result.items;
            this.total = res.result.totalCount;
            if (res.result.items.length == 0) {
              this.showList = false;
              this.showClear = false;
            } else {
              this.showClear = true;
            }
          }, 500);
        });
      } else if (val == "Reservation") {
        getReservationPageList(this.query).then((res) => {
          setTimeout(() => {
            this.loading = false;
            this.messageList = res.result.items;
            this.total = res.result.totalCount;
            if (res.result.items.length == 0) {
              this.showList = false;
              this.showClear = false;
            } else {
              this.showClear = true;
            }
          }, 500);
        });
      }
    },
    getMessage() {
      getMessageInfo().then((res) => {
        this.systemUnReadCount = res.result.systemUnReadCount;
        this.estateUnReadCount = res.result.estateUnReadCount;
        this.reservationUnReadCount = res.result.reservationUnReadCount;
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#message {
  .all-read {
    position: absolute;
    top: 6px;
    right: 40px;
    padding: 4px 14px;
    border: 1px solid $--color-primary;
    border-radius: 4px;
    font-size: 14px;
    color: $--color-primary;
    cursor: pointer;
  }
  .message-main {
    @include flex(row, stretch);
    padding: 20px;
    .message-menu {
      margin-right: 20px;
      padding: 38px 20px;
      width: 290px;
      min-height: calc(100vh - 210px);
      background: #fff;

      ::v-deep .message-type {
        @include flex(row, center);
        padding: 10px 10px 0 20px;
        height: 40px;
        line-height: 40px;
        color: #717171;
        cursor: pointer;
        .el-badge {
          .el-badge__content {
            right: 20px;
            top: 10px;
            padding: 0 3px;
          }
        }
        .svg {
          margin-right: 10px;
          font-size: 17px;
        }
        .message-svg {
          font-size: 20px;
        }
      }
      .message {
        ::v-deep .el-badge {
          .el-badge__content {
            padding: 0 6px;
          }
        }
      }

      .active {
        color: $--color-primary;
        background: rgba(255, 144, 0, 0.1);
      }
    }
    .message-table {
      position: relative;
      width: 100%;
      min-height: calc(100vh - 135px);
      background: #fff;
      ::v-deep .el-tabs {
        padding: 15px 25px;
        border-bottom: 1px solid #e0e0e0;
        .el-tabs__header {
          box-shadow: 0 0 0px rgba(0, 0, 0, 0);
        }
        .el-tabs__nav-wrap::after {
          color: #fff;
          height: 0;
        }
        .el-tabs__content {
          position: relative;
        }
      }
      .clear-message {
        position: absolute;
        top: 25px;
        right: 25px;
        font-size: 14px;
        color: #999;
        cursor: pointer;
      }
      .message-list {
        min-height: calc(100vh - 260px);
        .message-box {
          padding: 30px 26px;
          border-bottom: 1px solid #d0d0d0;
          .name {
            @include flex(row, center);
            margin-bottom: 10px;
            color: #666;
            .icon,
            .icon-read {
              display: inline-block;
              margin-right: 9px;
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background: #ff0000;
            }
            .isRead {
              background: #999;
            }
            .icon-read {
              background: #999;
            }
          }
          .content {
            margin-left: 15px;
            line-height: 1.5;
            color: #b0b1b0;
          }
          .details {
            margin-top: 10px;
            margin-left: 15px;
            color: $--color-primary;
            cursor: pointer;
          }
        }
        .message-box:last-child {
          border-bottom: 0;
        }
      }

      .pagination {
        padding: 10px 20px;
      }
      .none-box {
        text-align: center;
        color: #666;
        img {
          margin-top: calc((100vh - 385px) / 2);
          width: 250px;
          height: auto;
        }
      }
    }
  }

  .el-drawer {
    .drawer-title {
      height: 42px;
      span {
        position: absolute;
        right: 10px;
        cursor: pointer;
      }
    }
    .name {
      @include flex(row, center);
      margin-bottom: 10px;
      color: #000;
    }
    .content {
      margin-top: 10px;
      width: 500px;
      line-height: 1.5;
      color: #333;
    }
  }
}
</style>
